import { TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";
import { pageTableCellHeader } from "../../../../Constants/MockData";
import { tableLabelStyle } from "../../../../Utils/CommonStyles/muTableStyle";

const PageTableHeader = () => {
  return (
    <TableHead >
      <TableRow>
        {pageTableCellHeader?.map((tCell, index) => (
          <TableCell
            key={index}
            style={{
              ...tableLabelStyle,
              textAlign:
                index === pageTableCellHeader?.length - 1 ? "right" : "left",
            }}
          >
            {tCell?.header}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default PageTableHeader;
